import { render, staticRenderFns } from "./StaffHoursMembers.vue?vue&type=template&id=5d89605a&"
import script from "./StaffHoursMembers.vue?vue&type=script&lang=js&"
export * from "./StaffHoursMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports